import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_676a58ee from 'nuxt_plugin_plugin_676a58ee' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_nuxtcustomelementsplugin_e554640c from 'nuxt_plugin_nuxtcustomelementsplugin_e554640c' // Source: ./nuxt-custom-elements-plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_76d29ac3 from 'nuxt_plugin_cookieuniversalnuxt_76d29ac3' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_526e3a9e from 'nuxt_plugin_gtm_526e3a9e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_deviceplugin_184244b4 from 'nuxt_plugin_deviceplugin_184244b4' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_sentryplugin_293ddefc from 'nuxt_plugin_sentryplugin_293ddefc' // Source: ../plugins/_core/sentry.plugin.js (mode: 'client')
import nuxt_plugin_axiosplugin_dae9ddb6 from 'nuxt_plugin_axiosplugin_dae9ddb6' // Source: ../plugins/_core/axios.plugin.js (mode: 'all')
import nuxt_plugin_dialogplugin_44cad5b6 from 'nuxt_plugin_dialogplugin_44cad5b6' // Source: ../plugins/_core/dialog.plugin.js (mode: 'client')
import nuxt_plugin_tokenplugin_16b41230 from 'nuxt_plugin_tokenplugin_16b41230' // Source: ../plugins/_core/token.plugin.js (mode: 'all')
import nuxt_plugin_sessionplugin_1074d5f6 from 'nuxt_plugin_sessionplugin_1074d5f6' // Source: ../plugins/_core/session.plugin.js (mode: 'all')
import nuxt_plugin_servicesplugin_6b69c6fb from 'nuxt_plugin_servicesplugin_6b69c6fb' // Source: ../plugins/_core/services.plugin.js (mode: 'all')
import nuxt_plugin_coreplugin_57251708 from 'nuxt_plugin_coreplugin_57251708' // Source: ../plugins/_core/core.plugin.js (mode: 'all')
import nuxt_plugin_i18nplugin_4ca1278a from 'nuxt_plugin_i18nplugin_4ca1278a' // Source: ../plugins/_core/i18n.plugin.js (mode: 'all')
import nuxt_plugin_toastplugin_e6ca1cd4 from 'nuxt_plugin_toastplugin_e6ca1cd4' // Source: ../plugins/_core/toast.plugin.js (mode: 'client')
import nuxt_plugin_toastNotificationplugin_af01e63e from 'nuxt_plugin_toastNotificationplugin_af01e63e' // Source: ../plugins/_core/toastNotification.plugin.js (mode: 'client')
import nuxt_plugin_handTalkplugin_09470018 from 'nuxt_plugin_handTalkplugin_09470018' // Source: ../plugins/_core/handTalk.plugin.js (mode: 'client')
import nuxt_plugin_hooksplugin_e1eb1842 from 'nuxt_plugin_hooksplugin_e1eb1842' // Source: ../plugins/_core/hooks.plugin.js (mode: 'all')
import nuxt_plugin_equalwebplugin_1dc1b3bd from 'nuxt_plugin_equalwebplugin_1dc1b3bd' // Source: ../plugins/_core/equalweb.plugin.js (mode: 'client')
import nuxt_plugin_nuxtclientinit_fb97b5b0 from 'nuxt_plugin_nuxtclientinit_fb97b5b0' // Source: ../plugins/_core/nuxt-client-init.js (mode: 'client')
import nuxt_plugin_safeapermissiondirectiveplugin_2c52b367 from 'nuxt_plugin_safeapermissiondirectiveplugin_2c52b367' // Source: ../plugins/_core/safea-permission-directive.plugin.js (mode: 'all')
import nuxt_plugin_maisacomponentsplugin_02b17ddd from 'nuxt_plugin_maisacomponentsplugin_02b17ddd' // Source: ../plugins/_core/maisa-components.plugin.js (mode: 'client')
import nuxt_plugin_audplugin_aa684dc2 from 'nuxt_plugin_audplugin_aa684dc2' // Source: ../plugins/_core/aud.plugin.js (mode: 'all')
import nuxt_plugin_genericComponent_3b06481b from 'nuxt_plugin_genericComponent_3b06481b' // Source: ../plugins/genericComponent.js (mode: 'all')
import nuxt_plugin_vMask_6a2dc7ab from 'nuxt_plugin_vMask_6a2dc7ab' // Source: ../plugins/vMask.js (mode: 'all')
import nuxt_plugin_permission_d4a2bbdc from 'nuxt_plugin_permission_d4a2bbdc' // Source: ../plugins/permission.js (mode: 'all')
import nuxt_plugin_formatDateFilter_5f258584 from 'nuxt_plugin_formatDateFilter_5f258584' // Source: ../plugins/formatDateFilter.js (mode: 'all')
import nuxt_plugin_formatNumber_773725a1 from 'nuxt_plugin_formatNumber_773725a1' // Source: ../plugins/formatNumber.js (mode: 'all')
import nuxt_plugin_decode_e2f3bada from 'nuxt_plugin_decode_e2f3bada' // Source: ../plugins/decode.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"refreshOnceOnNavigation":true,"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Plataforma A","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Plataforma A"}],"script":[{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fmathjax@3\u002Fes5\u002Ftex-mml-chtml.js","defer":true},{"src":"https:\u002F\u002Fapis.google.com\u002Fjs\u002Fplatform.js?onload=init","defer":true},{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","defer":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fstring-strip-html\u002Fdist\u002Fstring-strip-html.umd.js"},{"src":"https:\u002F\u002Ff99e724789f2.edge.captcha-sdk.awswaf.com\u002Ff99e724789f2\u002Fjsapi.js","defer":true,"async":true},{"src":"https:\u002F\u002Fplugin.handtalk.me\u002Fweb\u002F11.2.4\u002Fhandtalk.min.js","defer":true,"crossorigin":"anonymous","integrity":"sha256-6Ss\u002Fyr2WbQDNwS+B49Ee+4s7HYsBrNYuY8D6UxIHOoA="},{"src":"https:\u002F\u002Fjs-cdn.dynatrace.com\u002Fjstag\u002F17b5f18726d\u002Fbf01002bli\u002Fc87341389533d7b8_complete.js","crossorigin":"anonymous"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-W423V2CV')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"preload","as":"style","type":"text\u002Fcss","href":"\u002Fplataforma\u002F_core\u002Ffonts\u002Findex.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"\u002Fplataforma\u002F_core\u002Ffonts\u002Findex.css"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-W423V2CV&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_676a58ee === 'function') {
    await nuxt_plugin_plugin_676a58ee(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcustomelementsplugin_e554640c === 'function') {
    await nuxt_plugin_nuxtcustomelementsplugin_e554640c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_76d29ac3 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_76d29ac3(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_526e3a9e === 'function') {
    await nuxt_plugin_gtm_526e3a9e(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_184244b4 === 'function') {
    await nuxt_plugin_deviceplugin_184244b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryplugin_293ddefc === 'function') {
    await nuxt_plugin_sentryplugin_293ddefc(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosplugin_dae9ddb6 === 'function') {
    await nuxt_plugin_axiosplugin_dae9ddb6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dialogplugin_44cad5b6 === 'function') {
    await nuxt_plugin_dialogplugin_44cad5b6(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenplugin_16b41230 === 'function') {
    await nuxt_plugin_tokenplugin_16b41230(app.context, inject)
  }

  if (typeof nuxt_plugin_sessionplugin_1074d5f6 === 'function') {
    await nuxt_plugin_sessionplugin_1074d5f6(app.context, inject)
  }

  if (typeof nuxt_plugin_servicesplugin_6b69c6fb === 'function') {
    await nuxt_plugin_servicesplugin_6b69c6fb(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin_57251708 === 'function') {
    await nuxt_plugin_coreplugin_57251708(app.context, inject)
  }

  if (typeof nuxt_plugin_i18nplugin_4ca1278a === 'function') {
    await nuxt_plugin_i18nplugin_4ca1278a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toastplugin_e6ca1cd4 === 'function') {
    await nuxt_plugin_toastplugin_e6ca1cd4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toastNotificationplugin_af01e63e === 'function') {
    await nuxt_plugin_toastNotificationplugin_af01e63e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_handTalkplugin_09470018 === 'function') {
    await nuxt_plugin_handTalkplugin_09470018(app.context, inject)
  }

  if (typeof nuxt_plugin_hooksplugin_e1eb1842 === 'function') {
    await nuxt_plugin_hooksplugin_e1eb1842(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_equalwebplugin_1dc1b3bd === 'function') {
    await nuxt_plugin_equalwebplugin_1dc1b3bd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinit_fb97b5b0 === 'function') {
    await nuxt_plugin_nuxtclientinit_fb97b5b0(app.context, inject)
  }

  if (typeof nuxt_plugin_safeapermissiondirectiveplugin_2c52b367 === 'function') {
    await nuxt_plugin_safeapermissiondirectiveplugin_2c52b367(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_maisacomponentsplugin_02b17ddd === 'function') {
    await nuxt_plugin_maisacomponentsplugin_02b17ddd(app.context, inject)
  }

  if (typeof nuxt_plugin_audplugin_aa684dc2 === 'function') {
    await nuxt_plugin_audplugin_aa684dc2(app.context, inject)
  }

  if (typeof nuxt_plugin_genericComponent_3b06481b === 'function') {
    await nuxt_plugin_genericComponent_3b06481b(app.context, inject)
  }

  if (typeof nuxt_plugin_vMask_6a2dc7ab === 'function') {
    await nuxt_plugin_vMask_6a2dc7ab(app.context, inject)
  }

  if (typeof nuxt_plugin_permission_d4a2bbdc === 'function') {
    await nuxt_plugin_permission_d4a2bbdc(app.context, inject)
  }

  if (typeof nuxt_plugin_formatDateFilter_5f258584 === 'function') {
    await nuxt_plugin_formatDateFilter_5f258584(app.context, inject)
  }

  if (typeof nuxt_plugin_formatNumber_773725a1 === 'function') {
    await nuxt_plugin_formatNumber_773725a1(app.context, inject)
  }

  if (typeof nuxt_plugin_decode_e2f3bada === 'function') {
    await nuxt_plugin_decode_e2f3bada(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
